import cn from 'classnames';
import React from 'react';

import RemoteIcon from '@/components/Icon/RemoteIcon';
import {getLocalizedStrings} from '@/services/localization/localizationService';

const InstallPwaPageContent = ({title, descriptionKey, icons, showInstallButton}) => {
    const localizedStrings = getLocalizedStrings();
    const isShowIcons = !!icons?.length;

    return (
        <>
            <h1 className='mb-2 whitespace-pre-line text-28 ml:text-36'>{title}</h1>
            <p
                className={cn('whitespace-pre-line text-16', {'ml:text-start': !showInstallButton})}
                dangerouslySetInnerHTML={{__html: localizedStrings[descriptionKey]}}
            />
            {isShowIcons && (
                <ul className='mt-8 flex flex-col items-start gap-4 text-16 ml:max-w-[330px] ml:gap-6'>
                    {icons.map((icon, i) => {
                        const {titleKey} = icon;
                        const title = localizedStrings.formatString(
                            localizedStrings[titleKey],
                            <div className='inline'>
                                <RemoteIcon className='inline fill-primary' icon={icon} />
                            </div>
                        );

                        if (!title) return null;

                        return (
                            <li key={i} className='flex w-full items-center gap-2'>
                                <div className='flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full border-2 border-tertiary bg-primary-dark font-bold text-romance'>
                                    {i + 1}
                                </div>
                                <span className='w-full flex-1 text-start'>{title}</span>
                            </li>
                        );
                    })}
                </ul>
            )}
        </>
    );
};

export default InstallPwaPageContent;
